import { CSSProperties } from 'react';
import { ImageRotation } from 'shared/dtos/out/document';
import { ImageBounds } from './types';

export function isRotated90Or270(rotation: ImageRotation): boolean {
  return rotation === 90 || rotation === 270;
}

export function resolveImageScale(params: {
  containerWidth: number;
  containerHeight: number;
  imageNaturalWidth: number;
  imageNaturalHeight: number;
  imageRotation: ImageRotation;
  scaleUp?: boolean;
}): number {
  const {
    containerWidth,
    containerHeight,
    imageNaturalWidth,
    imageNaturalHeight,
    imageRotation,
    scaleUp,
  } = params;

  if (
    containerWidth === 0 ||
    containerHeight === 0 ||
    imageNaturalWidth === 0 ||
    imageNaturalHeight === 0
  ) {
    return 0;
  }

  const rotated = isRotated90Or270(imageRotation);
  const effectiveWidth = rotated ? imageNaturalHeight : imageNaturalWidth;
  const effectiveHeight = rotated ? imageNaturalWidth : imageNaturalHeight;

  const scale = Math.min(
    containerWidth / effectiveWidth,
    containerHeight / effectiveHeight
  );

  return scaleUp ? scale : Math.min(scale, 1);
}

export function resolveMinimumImageScale(
  imageScale: number,
  minimumScaleFactor: number
): number {
  return imageScale + minimumScaleFactor * imageScale;
}

export function resolveImageBounds(
  imageNaturalWidth: number,
  imageNaturalHeight: number,
  imageRotation: ImageRotation
): ImageBounds {
  const rotated = isRotated90Or270(imageRotation);
  return {
    width: rotated ? imageNaturalHeight : imageNaturalWidth,
    height: rotated ? imageNaturalWidth : imageNaturalHeight,
  };
}

export function resolveTransformKey(
  containerWidth: number,
  containerHeight: number,
  imageRotation: ImageRotation
): string {
  return `${containerWidth}x${containerHeight}:r${imageRotation}`;
}

export function resolvePanPinchWrapperStyle(
  containerWidth: number,
  containerHeight: number
): CSSProperties {
  return {
    width: `${containerWidth}px`,
    height: `${containerHeight}px`,
  };
}
